export class OvpJobCondition {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {boolean} */
    isSpecial = false;

    /** @type {number} */
    period = 1;

    /**
     * @param {Object} obj
     * @returns {OvpJobCondition}
     */
    static fromArray(obj) {
       
        if (obj.ovpJobCondition || obj.globalOvpJobCondition) {
            obj.name = obj.ovpJobCondition.name || obj.globalOvpJobCondition.name;
        }

        return Object.assign(new this(), obj || {});
    }
}